//Reset data
export const RESET = "AGENT_CREATE_RESET"

//Loading
export const SET_TOGGLE_LOADING = "AGENT_CREATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "AGENT_CREATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AGENT_CREATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AGENT_CREATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "AGENT_CREATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AGENT_CREATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "AGENT_CREATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "AGENT_CREATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AGENT_CREATE_SET_HIDE_MESSAGE"

//Data
export const SET_CREATED = "AGENT_CREATE_SET_CREATED"
export const SET_IS_CREATED = "AGENT_CREATE_SET_IS_CREATED"
export const SET_NOT_CREATED = "AGENT_CREATE_SET_NOT_CREATED"
export const SET_CURRENT_ITEM = "AGENT_CREATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "AGENT_CREATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "AGENT_CREATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "AGENT_CREATE_SET_HIDE_MODAL"


export const SET_MODAL = "AGENT_CREATE_SET_MODAL"
export const SET_MODAL_CONTENT = "AGENT_CREATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "AGENT_CREATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "AGENT_CREATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "AGENT_CREATE_SET_MODAL_TYPE"